import { useInfiniteQuery } from '@tanstack/react-query'
import { rocketGameLiveService } from '../../../services/rockets-games-lives'
import type { GetList } from '../../../services/rockets-games-lives/types'

export const ROCKETS_GAMES_LIVES_QUERY_KEY = 'getRocketsGamesLives'

export const useGetRocketsGamesLives = (
  params?: GetList.Input,
  options?: { refetchInterval?: number },
) => {
  const { data, isFetchingNextPage, isLoading, refetch, fetchNextPage } =
    useInfiniteQuery({
      queryKey: [ROCKETS_GAMES_LIVES_QUERY_KEY, params],
      initialPageParam: 0,
      refetchInterval: options?.refetchInterval,
      queryFn: ({ pageParam: skip }) => {
        return rocketGameLiveService.getList({ take: 20, skip, ...params })
      },
      getNextPageParam: (lastPage, _allPages, lastPageParam) => {
        if (lastPage?.error) return null

        if (lastPage && !lastPage?.data?.length) return null

        return lastPageParam + 1
      },
    })

  return {
    rocketsGamesLives: data?.pages?.flatMap((page) => page?.data),
    isFetchingNextPage,
    isLoading,
    nextPage: fetchNextPage,
    refetch,
  }
}
